module.exports = __webpack_public_path__ + "resources/img/img_alyac2.e8af44d67676f3008333c8e8ddaa4b3a.png";